import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import { LocationOnOutlined as LocationIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const ScheduledLocation = ({ location, showLocationIcon }) => {
  const theme = useTheme();
  return (
    <Box display="flex">
      {showLocationIcon && (
        <Box mr={1} color={theme.palette.action.disabled}>
          <LocationIcon fontSize="small" />
        </Box>
      )}
      <Typography variant="body2" color="textSecondary">
        {`${location.city}, ${location.state}`}
      </Typography>
    </Box>
  );
};

const CourseCardLocation = ({ location, showLocationIcon }) => {
  return (
    <Box mt={0.5}>
      {location && (
        <ScheduledLocation
          location={location}
          showLocationIcon={showLocationIcon}
        />
      )}
    </Box>
  );
};

export default CourseCardLocation;

CourseCardLocation.propTypes = {
  location: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string
  }),
  courseType: PropTypes.string,
  showLocationIcon: PropTypes.bool
};

CourseCardLocation.defaultProps = {
  showLocationIcon: true
};
